import { matchEntries as jazz } from "@cdv/jazz-ui";
import Game from "./Game";
import HomepageAuth from "./HomepageAuth";
import Page from "./Page";
import User from "./User";
import Audio from "./Audio";
import Homepage from "./Homepage";
import GameAnt from "./GameAnt";
import TestDefinition from "./TestDefinition";
import TestVersion from "./TestVersion";
import Info from "./Info";
import Gdpr from "./Gdpr";

export default [
  ...jazz,
  ...Game,
  ...GameAnt,
  ...HomepageAuth,
  ...Homepage,
  ...Page,
  ...User,
  ...Audio,
  ...TestDefinition,
  ...TestVersion,
  ...Info,
  ...Gdpr,
];
